import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const courApi = createApi({
  reducerPath: 'courApi',
  baseQuery: fetchBaseQuery({
    // baseUrl: 'http://localhost:8000/api',
    // baseUrl: 'https://api.exchange-maroc.com/api',
    baseUrl: process.env.REACT_APP_BASE_URL,
    credentials: 'include',
  }),
  tagTypes: ["Cours"],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getAllCours: builder.query({
      query: () => ({ url: '/cours' }),
      providesTags: ['Cours'],
    }),
    getCour: builder.query({
      query: (id) => ({ url: `/cours/${id}` }),
      providesTags: ['Cours'],
    }),
    getCourBureau: builder.query({
      query: (id) => ({ url: `/cours/${id}/edit` }),
      providesTags: ['Cours'],
    }),
    addCour: builder.mutation({
      query: (body) => ({
        url: '/cours',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Cours'],
    }),
    deleteCour: builder.mutation({
      query: (id) => ({
        url: `/cours/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cours'],
    }),
  
    updateCour: builder.mutation({
      query: ({ id, cour }) => ({
        url: `/cours/${id}`,
        method: 'PUT', 
        body: cour,
      }),
      invalidatesTags: ['Cours'],
    }),
    updateCourPrices: builder.mutation({
      query: ({ id, cour }) => ({
        url: `/cours/update/${id}`,
        method: 'POST', 
        body: cour,
      }),
      invalidatesTags: ['Cours', 'Historiquecours'],
    }),



  }),
});

export const {
  useGetAllCoursQuery,
  useGetCourQuery,
  useGetCourBureauQuery,
  useAddCourMutation,
  useDeleteCourMutation,
  useUpdateCourMutation,
  useUpdateCourPricesMutation,
} = courApi;
